import { render } from "./woniuRecharge.vue?vue&type=template&id=7038c6fc&scoped=true"
import script from "./woniuRecharge.vue?vue&type=script&lang=js"
export * from "./woniuRecharge.vue?vue&type=script&lang=js"

import "./woniuRecharge.vue?vue&type=style&index=0&id=7038c6fc&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-7038c6fc"

export default script